module.exports = __webpack_public_path__ + "img/Button-kosik-2021-11.382ba312.png";